<div class="workspace-container prefab-config-settings">
  <div class="tabs-container tab-container">
    <div class="alert app-message alert-danger" *ngIf="hasError()">
      <div><i class="error icon wi wi-cancel"></i></div>
      <div [innerHTML]="getErrorMsg()"></div>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item" *ngFor="let tab of tabs" (click)="onTabSelect(tab)" [ngClass]="{'active': tab.isActive}">
        <a class="nav-link">{{tab.title}}</a>
      </li>
    </ul>
    <div class="prefab-properties">
      <router-outlet></router-outlet>
  </div>
  </div>
</div>
